import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#424242",
  "fill-rule": "evenodd",
  d: "M9.003 12.894q.955 0 1.802-.431a3.5 3.5 0 0 0 1.37-1.227.46.46 0 0 0 .038-.492.42.42 0 0 0-.398-.244.4.4 0 0 0-.353.198 3.1 3.1 0 0 1-1.076.956Q9.741 12 9 12t-1.386-.346a3.1 3.1 0 0 1-1.076-.956.5.5 0 0 0-.163-.147.4.4 0 0 0-.202-.051.42.42 0 0 0-.397.235q-.124.235.038.478.521.807 1.37 1.244a3.9 3.9 0 0 0 1.82.437zm2.552-4.788a.94.94 0 0 0 .694-.287.95.95 0 0 0 .285-.696.94.94 0 0 0-.287-.694.95.95 0 0 0-.696-.285.94.94 0 0 0-.694.287.95.95 0 0 0-.285.696q0 .41.287.694a.95.95 0 0 0 .696.285m-5.106 0a.94.94 0 0 0 .694-.287.95.95 0 0 0 .285-.696.94.94 0 0 0-.287-.694.95.95 0 0 0-.696-.285.94.94 0 0 0-.694.287.95.95 0 0 0-.285.696q0 .41.287.694a.95.95 0 0 0 .696.285M9 16.125a6.9 6.9 0 0 1-2.779-.561 7.2 7.2 0 0 1-2.262-1.523 7.2 7.2 0 0 1-1.524-2.261A6.9 6.9 0 0 1 1.875 9q0-1.477.561-2.779A7.2 7.2 0 0 1 3.959 3.96 7.2 7.2 0 0 1 6.22 2.436a6.9 6.9 0 0 1 2.778-.561q1.478 0 2.779.561a7.2 7.2 0 0 1 2.262 1.523 7.2 7.2 0 0 1 1.524 2.262q.561 1.299.561 2.778 0 1.478-.561 2.779a7.2 7.2 0 0 1-1.523 2.262 7.2 7.2 0 0 1-2.261 1.524A6.9 6.9 0 0 1 9 16.125"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }